//    ORDER STATUS
export const ORDER_STATUS = Object.freeze({
  CONFIRMED: 1,
  PROCESSING: 2,
  SHIPPED: 3,
  DELIVERED: 4,
  RETURNED: 5,
  CANCELED: 6,
  PENDING: 7,
  PARTIAL_DELIVERED: 8,
  PAYMENT_FAILED: 9,
});

//    ORDER ORIGIN
export const ORDER_ORIGIN = Object.freeze({
  WEB: 0,
  MBL: 1,
  BKO: 2,
  OTH: 3,
});

//    STATUS ID
export const STATUS_ID = Object.freeze({
  IN_ACTIVE: 0,
  ACTIVE: 1,
  DELETED: 2,
  DRAFT: 3,
  PUBLISHED: 4,
});

//    ENTITY TYPE
export const ENTITY_TYPE = Object.freeze({
  PRODUCT: 1,
  CATEGORY: 2,
  SHOP: 3,
  SLIDE: 4,
  ORDER: 5,
  ORDER_DETAIL: 6,
});

//    MEDIA ENTITY TYPE
export const MEDIA_ENTITY_TYPE = Object.freeze({
  PRODUCT: 1,
  CATEGORY: 2,
  SHOP: 3,
  SLIDE: 4,
  ORDER: 5,
  ORDER_DETAIL: 6,
  PRODUCT_REVIEW: 7,
});

//    AUDIT ENTITY TYPE
export const AUDIT_ENTITY_TYPE = Object.freeze({
  PRODUCT: 1,
  CATEGORY: 2,
  SHOP: 3,
  SLIDE: 4,
  ORDER: 5,
  ORDER_DETAIL: 6,
  PRODUCT_REVIEW: 7,
});

//    LABELS
export const ORDER_STATUS_LABELS = {
  1: "Confirmed",
  2: "Processing",
  3: "Shipped",
  4: "Delivered",
  5: "Returned",
  6: "Canceled",
  7: "Pending",
  8: "Partial Delivered",
  9: "Payment Failed",
};

export const ORDER_ORIGIN_LABELS = {
  0: "Web",
  1: "Mobile",
  2: "Back Office",
  3: "Other",
};

export const STATUS_ID_LABELS = {
  0: "Inactive",
  1: "Active",
  2: "Deleted",
  3: "Draft",
  4: "Published",
};

export const ENTITY_TYPE_LABELS = {
  1: "Product",
  2: "Category",
  3: "Shop",
  4: "Slide",
  5: "Order",
  6: "Order Detail",
};

export const MEDIA_ENTITY_TYPE_LABELS = {
  1: "Product",
  2: "Category",
  3: "Shop",
  4: "Slide",
  5: "Order",
  6: "Order Detail",
  7: "Product Review",
};

//    HELPERS

export const getOrderStatusLabel = (value) =>
  ORDER_STATUS_LABELS[value] || "Unknown";

export const getOrderOriginLabel = (value) =>
  ORDER_ORIGIN_LABELS[value] || "Unknown";

export const getStatusLabel = (value) => STATUS_ID_LABELS[value] || "Unknown";

export const getEntityTypeLabel = (value) =>
  ENTITY_TYPE_LABELS[value] || "Unknown";

export const getMediaEntityTypeLabel = (value) =>
  MEDIA_ENTITY_TYPE_LABELS[value] || "Unknown";

//    EXAMPLE

// ORDER_STATUS.CONFIRMED => 1
// ORDER_ORIGIN.MBL => 1
// STATUS_ID.ACTIVE => 1
// ENTITY_TYPE.PRODUCT => 1
// MEDIA_ENTITY_TYPE.PRODUCT_REVIEW => 7

// getOrderStatusLabel(3) => "Shipped"
// getOrderOriginLabel(1) => "Mobile"
